import React, { Component } from 'react';
import ImageList from './IdUpload';


export default class CpUpload extends Component {
  constructor(props){
    super(props);
    this.state={
      fileList: []
    }
  }
  onChange=(fileList)=>{
    this.setState({
      fileList
    })
  }
  render(){
    return <ImageList fileList={this.state.fileList} onChange={this.onChange}></ImageList>
  }
}